import * as React from "react";

import { container, type ServiceContainer } from "./container";

/**
 * ServiceProvider — Phase 6a.5 per spec §8.4.
 *
 * Components consume services via the convenience hooks below
 * (useCalculationService, etc.). Tests/Storybook can pass a custom
 * container via the `value` prop to swap in mocks.
 */
const ServiceContext = React.createContext<ServiceContainer | null>(null);

export function ServiceProvider({
  children,
  value,
}: {
  children: React.ReactNode;
  /** Optional override container (tests / Storybook). Defaults to global. */
  value?: ServiceContainer;
}) {
  return (
    <ServiceContext.Provider value={value ?? container}>
      {children}
    </ServiceContext.Provider>
  );
}

export function useServices(): ServiceContainer {
  const ctx = React.useContext(ServiceContext);
  if (!ctx) {
    throw new Error("useServices must be used within <ServiceProvider>");
  }
  return ctx;
}

// Convenience hooks
export const useCalculationService = () => useServices().calculationService;
export const useEngagementService = () => useServices().engagementService;
export const useHistoryStorage = () => useServices().historyStorage;
export const useAiAssistant = () => useServices().aiAssistant;
export const useFxRateProviders = () => useServices().fxRateProviders;
